// src/layouts/DashboardLayout.jsx
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';
import Navbar from '../Navbar';
import '../../css/dashboard.css';
import ScrollToTop from '../Utils/ScrollToTop';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const onlyHamburger = true;

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (!onlyHamburger && window.innerWidth >= 769) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="app-layout">
      <div className="header-navbar-wrapper">
        <Header 
          sidebarOpen={sidebarOpen} 
          toggleSidebar={toggleSidebar}
          onlyHamburger={onlyHamburger}
        />
        <ScrollToTop />
        <Navbar 
          sidebarOpen={sidebarOpen} 
          closeSidebar={closeSidebar}
          onlyHamburger={onlyHamburger}
        />
      </div>
      <div className="dashboard-container">
        <div className="dashboard-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
